//imported
import * as Path from "./paths";
//auth
import SignIn from "components/views/admin/auth/Login";
//forgot password
import ForgotPassword from "components/views/admin/auth/ForgotPassword";
import ResetPassword from "components/views/admin/auth/ResetPassword";

//profile
import Profile from "components/views/admin/profile/Profile";
//ChangePassword
import ChangePassword from "components/views/admin/profile/ChangePassword";

//dashboard
import Dashboard from "components/views/admin/dashboard/Dashboard";
//users
import UserList from "components/views/admin/user/Listing";
import UserPreferences from "components/views/admin/user/PreferencesList";

import UserDetail from "components/views/admin/user/Detail";
import UserAddEdit from "components/views/admin/user/AddEdit";
//coach
import CoachList from "components/views/admin/coach/Listing";
import CoachDetail from "components/views/admin/coach/Detail";
import CoachAddEdit from "components/views/admin/coach/AddEdit";
//category
import CategoryList from "components/views/admin/category/Listing";
import CategoryDetail from "components/views/admin/category/Detail";
import CategoryAddEdit from "components/views/admin/category/AddEdit";
//subcategory
import SubCategoryList from "components/views/admin/subcategory/Listing";
import SubCategoryDetail from "components/views/admin/subcategory/Detail";
import SubCategoryAddEdit from "components/views/admin/subcategory/AddEdit";
//post
import PostList from "components/views/admin/post/Listing";
import PostDetail from "components/views/admin/post/Detail";
import PostAddEdit from "components/views/admin/post/AddEdit";
//system access
import SystemAccessList from "components/views/admin/system_access/Listing";
import SystemAccessAddEdit from "components/views/admin/system_access/AddEdit";
import SystemAccessDetail from "components/views/admin/system_access/Detail";
//promocode
import PromocodeList from "components/views/admin/promocode/Listing";
import PromocodeAddEdit from "components/views/admin/promocode/AddEdit";
import PromocodeDetail from "components/views/admin/promocode/Detail";
//user promocode
import UserPromocodeList from "components/views/admin/user_promocode/Listing";
import UserPromocodeDetail from "components/views/admin/user_promocode/Detail";
//cms
import CMSList from "components/views/admin/cms/Listing";
import CMSAddEdit from "components/views/admin/cms/AddEdit";
import CmsContent from "components/publicCMS/CmsContent";
//FAQ
import FAQList from "components/views/admin/faq/Listing";
import FAQAddEdit from "components/views/admin/faq/AddEdit";
//Contact support
import ContactSupport from "components/views/admin/contact_support/Listing";
//Transactions
import TransactionList from "components/views/admin/transactions/Listing";
//Match
import MatchList from "components/views/admin/match/Listing";
import MatchListView from "components/views/admin/match/Detail";
//Payouts
import PayoutList from "components/views/admin/payouts/Listing";
import PayoutListView from "components/views/admin/payouts/Detail";
//Earning
import EarningList from "components/views/admin/earning/Listing";
import EarningListView from "components/views/admin/earning/Detail";
//Configuration
import ConfigurationAddEdit from "components/views/admin/configuration/AddEdit";
//reports
import Reports from "components/views/admin/reports/Listing";
//BasicSetting
import BasicSetting from "components/views/admin/basic_setting/Listing";
//not found page
import NotFound from "components/NotFound";
//support
import SupportList from "components/views/admin/support/Listing"
import MatchLogListing from "components/views/admin/match/matchLogs";
import FeedReport from "components/views/admin/feed_report/Listing";

const routes = [
  /******** login routes ***********/
  {
    path: Path.login,
    exact: true,
    auth: false,
    fallback: true,
    // component: lazy(() => import('components/views/admin/modules/auth/Login'))
    component: SignIn,
  },
  /******** forgot password routes ***********/
  {
    path: Path.forgot_password,
    exact: true,
    auth: false,
    component: ForgotPassword,
  },
  /******** reset password ***********/
  {
    path: Path.reset_password,
    exact: true,
    auth: false,
    component: ResetPassword,
  },
  /******** dashboard ***********/
  {
    path: Path.dashboard,
    exact: true,
    auth: true,
    component: Dashboard,
  },
  {
    path: Path.feed,
    exact: true,
    auth: true,
    component: FeedReport,
  },
  /******** transactions ***********/
  {
    path: Path.transaction,
    exact: true,
    auth: true,
    component: TransactionList,
  },
  /******** users***********/
  {
    path: Path.users,
    exact: true,
    auth: true,
    component: UserList,
  },
  {
    path: Path.usermatches,
    exact: true,
    auth: true,
    component: UserPreferences,
  },
  {
    path: Path.user_add,
    exact: true,
    auth: true,
    component: UserAddEdit,
  },
  {
    path: Path.user_edit,
    exact: true,
    auth: true,
    component: UserAddEdit,
  },
  {
    path: Path.useredit,
    exact: true,
    auth: true,
    component: UserAddEdit,
  },
  {
    path: Path.user_view,
    exact: true,
    auth: true,
    component: UserDetail,
  },
  {
    path: Path.userview,
    exact: true,
    auth: true,
    component: UserDetail,
  },
  /******** coach***********/
  {
    path: Path.coach,
    exact: true,
    auth: true,
    component: CoachList,
  },
  {
    path: Path.coach_add,
    exact: true,
    auth: true,
    component: CoachAddEdit,
  },
  {
    path: Path.coach_edit,
    exact: true,
    auth: true,
    component: CoachAddEdit,
  },
  {
    path: Path.coachedit,
    exact: true,
    auth: true,
    component: CoachAddEdit,
  },
  {
    path: Path.coach_view,
    exact: true,
    auth: true,
    component: CoachDetail,
  },
  {
    path: Path.coachview,
    exact: true,
    auth: true,
    component: CoachDetail,
  },
  /******** category ***********/
  {
    path: Path.category,
    exact: true,
    auth: true,
    component: CategoryList,
  },
  {
    path: Path.category_add,
    exact: true,
    auth: true,
    component: CategoryAddEdit,
  },
  {
    path: Path.category_edit,
    exact: true,
    auth: true,
    component: CategoryAddEdit,
  },
  {
    path: Path.categoryedit,
    exact: true,
    auth: true,
    component: CategoryAddEdit,
  },
  {
    path: Path.categoryview,
    exact: true,
    auth: true,
    component: CategoryDetail,
  },
  {
    path: Path.category_view,
    exact: true,
    auth: true,
    component: CategoryDetail,
  },
  /******** subcategory ***********/
  {
    path: Path.subcategory,
    exact: true,
    auth: true,
    component: SubCategoryList,
  },
  {
    path: Path.subcategory_add,
    exact: true,
    auth: true,
    component: SubCategoryAddEdit,
  },
  {
    path: Path.subcategoryadd,
    exact: true,
    auth: true,
    component: SubCategoryAddEdit,
  },
  {
    path: Path.subcategory_edit,
    exact: true,
    auth: true,
    component: SubCategoryAddEdit,
  },
  {
    path: Path.subcategoryedit,
    exact: true,
    auth: true,
    component: SubCategoryAddEdit,
  },
  {
    path: Path.subcategoryview,
    exact: true,
    auth: true,
    component: SubCategoryDetail,
  },
  {
    path: Path.subcategory_view,
    exact: true,
    auth: true,
    component: SubCategoryDetail,
  },
  /******** post ***********/
  {
    path: Path.post,
    exact: true,
    auth: true,
    component: PostList,
  },
  {
    path: Path.post_add,
    exact: true,
    auth: true,
    component: PostAddEdit,
  },
  {
    path: Path.post_edit,
    exact: true,
    auth: true,
    component: PostAddEdit,
  },
  {
    path: Path.postedit,
    exact: true,
    auth: true,
    component: PostAddEdit,
  },
  {
    path: Path.postview,
    exact: true,
    auth: true,
    component: PostDetail,
  },
  {
    path: Path.post_view,
    exact: true,
    auth: true,
    component: PostDetail,
  },
  /******** system access ***********/
  {
    path: Path.system_access,
    exact: true,
    auth: true,
    component: SystemAccessList,
  },
  {
    path: Path.system_access_add,
    exact: true,
    auth: true,
    component: SystemAccessAddEdit,
  },
  {
    path: Path.system_access_edit,
    exact: true,
    auth: true,
    component: SystemAccessAddEdit,
  },
  {
    path: Path.system_accessedit,
    exact: true,
    auth: true,
    component: SystemAccessAddEdit,
  },
  {
    path: Path.system_accessview,
    exact: true,
    auth: true,
    component: SystemAccessDetail,
  },
  {
    path: Path.system_access_view,
    exact: true,
    auth: true,
    component: SystemAccessDetail,
  },
  /**************Profile**********/
  {
    path: Path.profile,
    exact: true,
    auth: true,
    component: Profile,
  },
  /**************Change password**********/
  {
    path: Path.change_password,
    exact: true,
    auth: true,
    component: ChangePassword,
  },
  /******** cms ***********/
  {
    path: Path.cms,
    exact: true,
    auth: true,
    component: CMSList,
  },
  {
    path: Path.cms_form,
    exact: true,
    auth: true,
    component: CMSAddEdit,
  },
  {
    path: Path.cmsform,
    exact: true,
    auth: true,
    component: CMSAddEdit,
  },
  {
    path: Path.cmsPage,
    exact: true,
    auth: false,
    component: CmsContent,
  },
  {
    path: Path.cms_Page,
    exact: true,
    auth: false,
    component: CmsContent,
  },
  /******** faq ***********/
  {
    path: Path.faq,
    exact: true,
    auth: true,
    component: FAQList,
  },
  {
    path: Path.faq_form,
    exact: true,
    auth: true,
    component: FAQAddEdit,
  },
  {
    path: Path.faqform,
    exact: true,
    auth: true,
    component: FAQAddEdit,
  },
  /******** match ***********/
  {
    path: Path.match,
    exact: true,
    auth: true,
    component: MatchList,
  },
  {
    path: Path.match_logs,
    exact: true,
    auth: true,
    component: MatchLogListing,
  },
  {
    path: Path.match_view,
    exact: true,
    auth: true,
    component: MatchListView,
  },
  {
    path: Path.matchview,
    exact: true,
    auth: true,
    component: MatchListView,
  },
  
  /******** earning ***********/
  {
    path: Path.earning,
    exact: true,
    auth: true,
    component: EarningList,
  },
  {
    path: Path.earning_view,
    exact: true,
    auth: true,
    component: EarningListView,
  },
  {
    path: Path.earningview,
    exact: true,
    auth: true,
    component: EarningListView,
  },
  /******** manage_payouts ***********/
  {
    path: Path.manage_payouts,
    exact: true,
    auth: true,
    component: PayoutList,
  },
  {
    path: Path.manage_payouts_view,
    exact: true,
    auth: true,
    component: PayoutListView,
  },
  {
    path: Path.manage_payoutsview,
    exact: true,
    auth: true,
    component: PayoutListView,
  },
  /******** promocode ***********/
  {
    path: Path.promocode,
    exact: true,
    auth: true,
    component: PromocodeList,
  },
  {
    path: Path.promocode_add,
    exact: true,
    auth: true,
    component: PromocodeAddEdit,
  },
  {
    path: Path.promocode_edit,
    exact: true,
    auth: true,
    component: PromocodeAddEdit,
  },
  {
    path: Path.promocodeedit,
    exact: true,
    auth: true,
    component: PromocodeAddEdit,
  },
  {
    path: Path.promocode_view,
    exact: true,
    auth: true,
    component: PromocodeDetail,
  },
  {
    path: Path.promocodeview,
    exact: true,
    auth: true,
    component: PromocodeDetail,
  },

  /******** user promocode ***********/
  {
    path: Path.user_promocode,
    exact: true,
    auth: true,
    component: UserPromocodeList,
  },
  {
    path: Path.user_promocode_view,
    exact: true,
    auth: true,
    component: UserPromocodeDetail,
  },
  {
    path: Path.userpromocodeview,
    exact: true,
    auth: true,
    component: UserPromocodeDetail,
  },
  /******** Configuration ***********/
  {
    path: Path.configuration_add,
    exact: true,
    auth: true,
    component: ConfigurationAddEdit,
  },
  /******** BasicSetting ***********/
  {
    path: Path.basic_setting,
    exact: true,
    auth: true,
    component: BasicSetting,
  },
  /**************Contact support**********/
  {
    path: Path.contact_support,
    exact: true,
    auth: true,
    component: ContactSupport,
  },
  /******** report list ***********/
  {
    path: Path.report_list,
    exact: true,
    auth: true,
    component: Reports,
  },
  /**Support */
  {
    path: Path.support_list,
    exact: true,
    auth: true,
    component: SupportList,
  },
  /******** not found page ***********/
  {
    path: "",
    exact: false,
    component: NotFound,
  },
];

export default routes;
